import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "upcoming-items scroll-wrapper"
}
const _hoisted_2 = { class: "upcoming-item__label" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "muted-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title" }, "Upcoming actions", -1)),
    ($props.upcomingArray.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.upcomingArray, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "upcoming-item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createTextVNode(_toDisplayString($setup.actionText(item.action === "Review EOI Requests" ? "Review Contract Form" : item.action)) + " ", 1),
                _createElementVNode("span", {
                  class: "highlighted",
                  onClick: ($event: any) => ($setup.actionRouting(item.stageId, item.lotId))
                }, "Lot " + _toDisplayString(item.lotTitle), 9, _hoisted_3)
              ]),
              _createElementVNode("div", {
                class: "upcoming-item__view",
                onClick: ($event: any) => ($setup.actionRouting(item.stageId, item.lotId))
              }, "View", 8, _hoisted_4)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_5, "You have no upcoming actions"))
  ]))
}